<template>
  <div class="page">
    <top-header></top-header>
    <b-container fluid>
      <b-row class="mt-3 mb-2">
        <b-col class="col-md-9 col-sm-9 col-xs-12 text-left">
          <h3>
            Water Level Record: <b>{{ livedata.location }}</b>
          </h3>
        </b-col>
        <b-col class="col-md-3 col-sm-3 col-xs-12 text-right">
          <!--<b-button variant="dark" @click="downloadcsv()">Export</b-button>-->
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <b-img src="../assets/high-water-tank.jpg" class="table-shadow" center fluid></b-img>
            </b-col>
            <b-col>
              <p class="font-md font-bold mb-0">WATER TANK LEVEL (%)</p>
              <p style="font-size:50px" class="mt-0">{{ level_per }}%</p>
              <p class="font-md font-bold mb-0">WATER TANK LEVEL (mtr)</p>
              <p style="font-size:40px">{{ level_mtr }}</p>

              <div class="table-shadow p-2 font-md" style="background-color:#ffffff">
                <b-row>
                  <b-col class="text-left font-bold pr-0">
                    SL Voltage
                  </b-col>
                  <b-col class="text-right pl-0"> {{ livedata.sl_voltage }}V </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-left font-bold pr-0">
                    Data Stamp
                  </b-col>
                  <b-col class="text-right pl-0">
                    {{ $moment(livedata.update_time).format("DD-MM-YYYY HH:mm:ss") }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="text-left font-bold pr-0">
                    Power
                  </b-col>
                  <b-col class="text-right pl-0">
                    <h4>
                      <b-badge v-if="conn_status == 1" pill variant="success">ON</b-badge>
                      <b-badge v-else pill variant="danger">OFF</b-badge>
                    </h4>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="col-md-5 col-sm-12 col-xs-12">
          <div
            style="min-height: 100px; background-color: #d3d0d000;padding:15px; display: flex; flex-direction: column;"
            class="table-shadow"
          >
            <b-row class="mb-3">
              <b-col lg="6" class="text-left font-bold">
                LIVE DATA
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col lg="6" class="text-left">
                <label class="mr-2">Show</label>
                <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                </b-form-select>
                <span class="ml-2">entries</span>
              </b-col>
              <b-col lg="4" offset-md="2">
                <b-form-group
                  label="Filter"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
                    </b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12">
                <b-table
                  show-empty
                  sticky-header
                  small
                  striped
                  outlined
                  stacked="md"
                  :items="records"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :filterIncludedFields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(output_status)="row">
                    <b-badge pill variant="success" v-if="row.value == 1">ON</b-badge>
                    <b-badge pill variant="danger" v-else>OFF</b-badge>
                  </template>
                  <template v-slot:cell(door_status)="row">
                    <b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
                    <b-badge pill variant="success" v-else>CLOSED</b-badge>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col lg="6" class="text-left">
                <span class="mr-2"
                  >Showing {{ (currentPage - 1) * perPage }} to {{ currentPage * perPage }} of
                  {{ records.length }} entries</span
                >
              </b-col>
              <b-col lg="6">
                <b-pagination
                  v-model="currentPage"
                  pills
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="right"
                  size="sm"
                  prev-text="Prev"
                  next-text="Next"
                  first-number
                  last-number
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  name: "Devices",
  components: {
    "top-header": Header,
  },
  mounted() {
    this.initload();
  },
  data() {
    var self = this;
    return {
      email: "",
      conn_status: 0,
      level_mtr: 0,
      level_per: 0,
      url: this.$root.httpurl + "api-wms/device-data",
      imeino: self.$route.params.imeino,
      records: [],
      livedata: {},
      fields: [
        {
          key: "analoginput",
          label: "Water Level",
          class: "text-left",
          formatter: (value, key, item) => {
            var height = JSON.parse(self.livedata.tank_height).overflow;
            var sensor_height = self.livedata.sensor_height;
            var level = 0;
            var min = self.livedata.level_min;
            var max = min + parseInt(((self.livedata.level_max - self.livedata.level_min) * height) / sensor_height);

            var unit = (max - min) / height;

            if (item.analoginput <= min) {
              level = 0;
            }
            if (item.analoginput >= max) {
              level = Number(height);
            }
            if (item.analoginput > min && item.analoginput < max) {
              level = (item.analoginput - min) / unit; // current level in meter
            }
            return level.toFixed(2);
          },
        },
        {
          key: "insert_time",
          label: "TimeStamp",
          class: "text-right",
          formatter: (value, key, item) => {
            var self = this;
            return self.$moment(item.insert_time).format("DD-MM-YYYY HH:mm:ss");
          },
        },
      ],
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      min_level: 1050,
      unit_meter: 20,
    };
  },
  methods: {
    initload() {
      var self = this;
      self.axios
        .post(self.url, {
          accesskey: self.$session.get("access_key"),
          imeino: self.imeino,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.livedata = response.data.result.livedata;

            self.records = response.data.result.records;
            self.loading = false;
            self.totalRows = self.records.length;

            var curdatetime = self.$moment();
            var dbdatetime = self.$moment(self.livedata.update_time);
            var duration = 0;
            var minutes = 0;
            if (curdatetime > dbdatetime) {
              duration = self.$moment.duration(curdatetime.diff(dbdatetime));
            } else {
              duration = self.$moment.duration(dbdatetime.diff(curdatetime));
            }
            minutes = duration.asMinutes();

            if (minutes < self.$root.disconnection_time) {
              self.conn_status = 1;
            } else {
              self.conn_status = 0;
            }

            var height = JSON.parse(self.livedata.tank_height).overflow;
            var sensor_height = self.livedata.sensor_height;
            var level = 0;
            var min = self.livedata.level_min;
            var max = min + parseInt(((self.livedata.level_max - self.livedata.level_min) * height) / sensor_height);

            console.log('self.livedata.analoginput:'+self.livedata.analoginput+'========min:'+max+'max:'+max+'sensor_height:'+sensor_height);

            var unit = (max - min) / height;

            if (self.livedata.analoginput <= min) {
              level = 0;
            }
            if (self.livedata.analoginput >= max) {
              level = Number(height);
            }
            if (self.livedata.analoginput > min && self.livedata.analoginput < max) {
              level = (self.livedata.analoginput - min) / unit; // current level in meter
            }
            if (self.livedata.analoginput == null) {
              level = 0;
              self.level_mtr = "0.00";
              self.level_per = "0.00";
            } else {
              console.log('Develop:'+level);
              self.level_mtr = level.toFixed(2);
              self.level_per = ((level / height) * 100).toFixed(2);
            }

            setTimeout(self.initload, self.$root.reload_duration);
          } else {
            self.$root.forceLogout(response.data.message);
          }
        })
        .catch(function(error) {
          alert(error);
        });
      //alert('login '+self.email+" "+self.password);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    downloadcsv() {
      var self = this;
      var header = new Array();
      self.fields.forEach(function(item) {
        if (!item.extra) {
          header.push(item.label);
        }
      });

      //var d = table.rows().data();
      var finalarr = new Array();
      finalarr.push(header);
      self.records.forEach(function(row) {
        var dataarr = new Array();
        self.fields.forEach(function(field) {
          if (field.key != "extra") {
            dataarr.push(row[field.key]);
          }
        });
        finalarr.push(dataarr);
      });

      let csvContent = "data:text/csv;charset=utf-8," + finalarr.map((e) => e.join(",")).join("\n");

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "device_data_report.csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    },
  },
};
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-color: "#FFF" !important;
  background-image: none !important;
}
.table {
  font-size: small;
}
.table td,
.table th {
  vertical-align: middle;
}
</style>
